import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as moment from 'moment';
import { defaultStore, initializeDefaultStore, loadState, combinedReducer } from '../common/redux-state'
import { storeUrl } from '../common/redux-state/actions/listing';
import { ProviderApp } from './components/app';
import { storeFilterOptions, upsertFilter } from '../common/redux-state/actions/filters';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

var search = document.getElementById("generic-entry-js");
var query = search.getAttribute("data-query");
var filter = search.getAttribute("data-filter");
var pageId = search.getAttribute("data-page-id");

defaultStore.dispatch(storeUrl(`/api/SearchResult/GetGeneric?pageId=${pageId}&`));
defaultStore.dispatch(storeFilterOptions("/api/SearchResult/GetGenericFilters") as any);
defaultStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));

var defaultSearchBox = query;
if (filter) {
    defaultStore.dispatch(upsertFilter("type", filter));
}
const savedState = loadState("genericState");

let updatedStore;

if (savedState) {
    savedState.filtersState.currentMonth = moment(savedState.filtersState.currentMonth);
    updatedStore = createStore(combinedReducer, savedState, applyMiddleware(thunk));
    defaultSearchBox = savedState.filtersState.filters["QueryValue"];
}

initializeDefaultStore(updatedStore ? updatedStore : defaultStore);
var prevQuery = sessionStorage.getItem("prevQueryString")
if (prevQuery != query && updatedStore) {
    sessionStorage.setItem("prevQueryString", query);
    updatedStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));
    defaultSearchBox = query;
}

render(<Provider store={updatedStore ? updatedStore : defaultStore}>
    <ProviderApp searchBoxDefault={defaultSearchBox} />
</Provider>, search);
